import {
  AlgunaCheckout as AlgunaCheckoutSdkEmbed,
  Appearance,
} from '@alguna/checkout-sdk/react';

import { EmbedProps } from './useAlgunaCheckout';

type AlgunaCheckoutEmbedProps = {
  embed: EmbedProps;
  className?: string;
  onScroll?: (deltaY: number) => void;
};

const APPEARANCE: Appearance = {
  preset: 'minimal',
  mode: 'light',
  accentColor: '#6633ee', // var(--primary)
  borderRadius: 10, // ~var(--radius-sm)
  fontFamily: 'Inter, sans-serif', // var(--font-family-base)
  density: 'compact',
  colors: {
    surface: '#ffffff', // var(--body-bg)
    card: '#ffffff',
    text: '#2a2b3a', // var(--text-body) / var(--grey-80)
    mutedText: '#5e6077', // var(--text-secondary) / var(--grey-60)
    border: 'transparent',
    inputBorder: '#ececfb', // var(--grey-20)
    inputBackground: '#ffffff',
  },
};

/**
 * Alguna's embedded checkout in Evervault's styling. The host renders its own
 * submit button and calls `submit` on the controller from `useAlgunaCheckout`.
 */
export function AlgunaCheckoutEmbed({
  embed,
  className,
  onScroll,
}: AlgunaCheckoutEmbedProps) {
  return (
    <AlgunaCheckoutSdkEmbed
      ref={embed.ref}
      url={embed.url}
      appearance={APPEARANCE}
      layout="compact"
      hidePayButton
      hidePaymentSecurityText
      showSavedPaymentMethods={false}
      className={className}
      onScroll={onScroll}
      onCheckoutStateChange={embed.onCheckoutStateChange}
      onRender={embed.onRender}
      onComplete={embed.onComplete}
      onError={embed.onError}
    />
  );
}
